import { HistoryTable } from 'features/downline-explorer/history-table/HistoryTable';
import { useTranslation } from 'libs/translations';
import { JSX } from 'react';
// eslint-disable-next-line no-restricted-imports
import { MdOutlineHistory } from 'react-icons/md';
import { NavLink } from 'react-router-dom';

interface IExpandedBlockProps {
  readonly userId: string;
  readonly context?: 'downline-explorer' | 'analytics';
}

export function ExpandedBlock({
  userId,
  context = 'downline-explorer'
}: IExpandedBlockProps): JSX.Element | null {
  const { t } = useTranslation();

  return (
    <div className="space-y-4 p-4">
      <div className="w-full flex items-center gap-4">
        <h2 className="flex items-center gap-1">
          <MdOutlineHistory />
          {t('History')}
        </h2>

        <NavLink
          to={`/downline/pathTo?userId=${userId}`}
          rel="noreferrer"
          className="flex flex-row flex-nowrap gap-xs items-center w-fit text-primary hover:text-active"
        >
          <span>{t('Go to dashboard')}</span>
        </NavLink>

        {context === 'analytics' && (
          <NavLink
            to={`/downline/pathTo/structure?userId=${userId}`}
            rel="noreferrer"
            className="flex flex-row flex-nowrap gap-xs items-center w-fit text-primary hover:text-active"
          >
            <span>{t('Go to My Team')}</span>
          </NavLink>
        )}
      </div>
      <HistoryTable userId={userId} />
    </div>
  );
}
